import { computed, defineComponent, ref, useContext, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'RatingItem',
    props: {
        card: {
            default: () => ({}),
            type: Object,
        },
        columnsLimit: {
            default: 0,
            type: Number,
        },
        head: {
            default: () => ({}),
            type: Object,
        },
        withAssets: {
            default: false,
            type: Boolean,
        },
        withPosition: {
            default: true,
            type: Boolean,
        },
    },
    setup(props) {
        /**
         * Composables.
         */
        const context = useContext();
        const css = useCssModule();
        const viewport = context.$viewport;
        const isTriggerAvailable = computed(() => Object.keys(props.card.columns).length > props.columnsLimit);
        const nameComponent = computed(() => {
            let component = 'div';
            let attrs = {};
            if (Number(props.card?.profile?.status)) {
                component = 'NLink';
                attrs = {
                    target: '_blank',
                    to: `/${props.card.profile?.url_alias || ''}`,
                };
            }
            return {
                component,
                attrs,
            };
        });
        /**
         * Bool states
         */
        const isTriggerShown = ref(false);
        /**
         * All columns keys.
         */
        const columnsKeys = computed(() => Object.keys(props.card.columns));
        /**
         * Main columns keys.
         */
        const columnsMain = computed(() => {
            const size = viewport.isLessThan('desktop') ? 2 : props.columnsLimit;
            return columnsKeys.value.slice(0, size);
        });
        /**
         * Additional columns keys.
         */
        const columnsAdditional = computed(() => {
            const size = viewport.isLessThan('desktop') ? 2 : props.columnsLimit;
            if (columnsKeys.value.length <= size) {
                return [];
            }
            return columnsKeys.value.slice(size);
        });
        /**
         * Profile assets
         */
        const profileAssets = computed(() => {
            if (!props.card.profile?.properties?.length) {
                return '';
            }
            const property = props.card.profile.properties.find(({ title }) => {
                return ['активы'].includes(title.trim().toLowerCase());
            });
            return property?.value || '';
        });
        /**
         * Profile subtitle
         */
        const profileSubtitle = computed(() => {
            if (!props.card.profile?.properties?.length) {
                return '';
            }
            const property = props.card.profile.properties.find(({ title }) => {
                return ['должность', 'отрасль', 'вид деятельности', 'деятельность'].includes(title.trim().toLowerCase());
            });
            return property?.value || '';
        });
        /**
         * Profile suffix
         */
        const profileSuffix = computed(() => {
            const [, , thirdKey] = Object.keys(props.head);
            return props.card.columns?.[thirdKey];
        });
        function handleMouseenter() {
            isTriggerShown.value = true;
        }
        function handleMouseleave() {
            isTriggerShown.value = false;
        }
        function shouldShowTrigger(index) {
            return index === columnsMain.value.length - 1 && columnsAdditional.value.length;
        }
        return {
            columnsAdditional,
            columnsKeys,
            columnsMain,
            css,
            handleMouseenter,
            handleMouseleave,
            isTriggerAvailable,
            isTriggerShown,
            nameComponent,
            profileAssets,
            profileSubtitle,
            profileSuffix,
            shouldShowTrigger,
        };
    },
});
